import { render, staticRenderFns } from "./PartCommandDykjModal.vue?vue&type=template&id=ecd4b580&scoped=true"
import script from "./PartCommandDykjModal.vue?vue&type=script&lang=js"
export * from "./PartCommandDykjModal.vue?vue&type=script&lang=js"
import style0 from "./PartCommandDykjModal.vue?vue&type=style&index=0&id=ecd4b580&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd4b580",
  null
  
)

export default component.exports